export const getRoomIdFromLocation = (): string => {
    const url = new URL(window.location.href);
    const segments = url.pathname.split('/').filter(Boolean);

    return segments[segments.length - 1];
};
